import { ClipboardList } from 'lucide-react';

export function EmptyState({ title, detail }: { title: string; detail?: string }) {
  return (
    <div className="empty-state">
      <ClipboardList size={66} strokeWidth={1.3} aria-hidden="true" />
      <p>{title}</p>
      {detail && <small>{detail}</small>}
    </div>
  );
}
